import { createContext, useState, useContext } from "react";

const AnalyzeLayoutContext = createContext();

export const DashboardProvider = ({ children }) => {
  const [filters, setFilters] = useState({
    selectedAssets: [],
    period: null,
    tenantID: null
  });

  return (
    <AnalyzeLayoutContext.Provider value={{ filters, setFilters }}>
      {children}
    </AnalyzeLayoutContext.Provider>
  );
};

export const useAnalyzeLayout = () => useContext(AnalyzeLayoutContext);